import script from "./KAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./KAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./KAccordion.vue?vue&type=style&index=0&id=02df4323&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02df4323"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
